import Vue from "vue";
import Router from "vue-router";

//Admin Routes
import Admin from "./views/Admin/Index.vue";
import AdminDashboard from "./components/Admin/Dashboard.vue";
import AdminProjects from "./views/Admin/Projects";
import CreateAdmin from "./components/Admin/CreateAdmin.vue";
import AdminProjectDetails from "./components/Admin/ProjectDetails.vue";
import EditCertificationProject from "./components/Admin/EditCertificationProject";
import EditListingProject from "./components/Admin/EditListingProject";
import AdminSectors from "./components/Admin/Sector";

//Shared Routes
import Profile from "./components/Shared/Profile/ProfileContainer.vue";
import Payments from "./views/Shared/Payments";
import Login from "./views/Shared/Login";
import Register from "./views/Shared/Register";
import Home from "./views/Shared/Home.vue";
import Error from "./views/Shared/Error.vue";
import RegisterInitial from "./components/Shared/Initial.vue";

//Offsetter
import CreateOffsetter from "./components/Offsetter/CreateOffsetter.vue";
import OffsetProjects from "./views/Offsetter/Projects";
import Offsetter from "./views/Offsetter/Index.vue";
import OffsetterDashboard from "./components/Offsetter/Dashboard.vue";
import OffsetInitial from "./components/Offsetter/Offset/OffsetInitial";
import OffsetterCalculatorInitial from "./components/Offsetter/Offset/OffsetContainer";
import CarbonAudit from "./components/Offsetter/Offset/CarbonAudit";
import OffsetterProjectDetails from "./components/Offsetter/ProjectDetails.vue";

//Broker
import CreateBroker from "./components/Broker/CreateBroker";

//Lister Routes
import Projects from "./views/Lister/Projects";
import CreateLister from "./components/Lister/CreateLister.vue";
import AddProject from "./components/Lister/AddProject";
import AddCertificationProject from "./components/Lister/AddCertificationProject.vue";
import AddListingProject from "./components/Lister/AddListingProject";
import ProjectInitial from "./components/Lister/ProjectInitial.vue";
import ProjectDetails from "./components/Lister/ProjectDetails.vue";
import Lister from "./views/Lister/Index.vue";
import ListerDashboard from "./components/Lister/Dashboard.vue";

import LandingProjects from "./views/Shared/Projects";
import SingleLandingProject from "./views/Shared/HomeProjectDetails";

Vue.use(Router);

//   base: process.env.BASE_URL,
const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/auth/login",
    name: "login",
    component: Login
  },
  {
    path: "/home/projects",
    name: "project",
    component: LandingProjects
  },
  {
    path: "/home/project/:id",
    name: "single-project",
    component: SingleLandingProject
  },
  {
    path: "/auth/register",
    name: "Register",
    component: Register,
    children: [
      {
        path: "",
        component: RegisterInitial,
        name: "register-initial"
      },
      {
        path: "/auth/register/lister",
        component: CreateLister,
        name: "register-lister"
      },
      {
        path: "/auth/register/offsetter",
        component: CreateOffsetter,
        name: "register-offsetter"
      },
      {
        path: "/auth/register/broker",
        component: CreateBroker,
        name: "register-broker"
      }
    ]
  },

  {
    path: "/admin",
    name: "admin",
    component: Admin,
    children: [
      {
        path: "",
        component: AdminDashboard,
        name: "admin-dashboard"
      },
      {
        path: "/admin/profile",
        component: Profile,
        name: "admin-profile"
      },
      {
        path: "/admin/projects",
        component: AdminProjects,
        name: "admin-projects"
      },
      {
        path: "/admin/register/admin",
        component: CreateAdmin,
        name: "register-admin"
      },
      {
        path: "/admin/project/:id",
        component: AdminProjectDetails,
        name: "admin-project-details"
      },
      {
        path: "/admin/project/certify/:id",
        component: EditCertificationProject,
        name: "admin-edit-certification"
      },
      {
        path: "/admin/project/list/:id",
        component: EditListingProject,
        name: "admin-edit-lisiting"
      },
      {
        path: "/admin/sectors",
        component: AdminSectors,
        name: "admin-sectors"
      }
    ]
  },

  {
    path: "/lister",
    name: "lister",
    component: Lister,
    children: [
      {
        path: "",
        component: ListerDashboard,
        name: "lister-dashboard"
      },
      {
        path: "/lister/profile",
        component: Profile,
        name: "lister-profile"
      },
      {
        path: "/lister/projects",
        component: Projects,
        name: "lister-projects"
      },
      {
        path: "/lister/payments",
        component: Payments,
        name: "lister-payments"
      },
      {
        path: "/lister/project/add/initial",
        component: ProjectInitial,
        name: "lister-add-project-initial"
      },
      {
        path: "/lister/project/add/verification",
        component: AddProject,
        name: "lister-add-project"
      },
      {
        path: "/lister/project/add/certification",
        component: AddCertificationProject,
        name: "lister-add-certification"
      },
      {
        path: "/lister/project/add/listing",
        component: AddListingProject,
        name: "lister-add-listing"
      },
      {
        path: "/lister/project/:id",
        component: ProjectDetails,
        name: "lister-project-details"
      }
    ]
  },

  {
    path: "/offsetter",
    name: "offsetter",
    component: Offsetter,
    children: [
      {
        path: "",
        component: OffsetterDashboard,
        name: "offsetter-dashboard"
      },
      {
        path: "/offsetter/profile",
        component: Profile,
        name: "offsetter-profile"
      },
      {
        path: "/offsetter/initial",
        component: OffsetInitial,
        name: "offsetter-initial"
      },
      {
        path: "/offsetter/offset/calculator",
        component: OffsetterCalculatorInitial,
        name: "offsetter-calculator-initial"
      },
      {
        path: "/offsetter/offset/audit",
        component: CarbonAudit,
        name: "carbon-audit"
      },
      {
        path: "/offsetter/projects/offset",
        component: OffsetProjects,
        name: "offsetter-offset-project"
      },
      {
        path: "/offsetter/project/:id",
        component: OffsetterProjectDetails,
        name: "offsetter-project-details"
      }
    ]
  },
  {
    path: "*",
    name: "NotFound",
    component: Error
  }
];

const router = new Router({
  mode: "history",
  routes,
  scrollBehavior: function(to) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
